module.exports = __webpack_public_path__ + "static/media/exterminador_d.d9f90d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/exterminador_d.png
// module id = 1158
// module chunks = 0